import React, { Component, Fragment } from "react";
import Options from "./options";
import PropTypes from "prop-types";
import styles from "./questions.module.scss";

class Questions extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedOption: -1
		};
	}

	componentDidMount = () => {
		this.checkIfOptionIsAlreadySelected();
	};

	onOptionClick = id => {
		this.setState({
			selectedOption: id
		});
		this.props.addAnswersToArray({
			questionId: this.props.question.id,
			optionId: id
		});
		this.props.saveAnswer({
			questionId: this.props.question.id,
			optionId: id
		});
	};

	checkIfOptionIsAlreadySelected = () => {
		let currentOption;
		this.props.surveyAnswers.map(answer => {
			currentOption = this.props.question.options.find(
				option => option.id === answer.optionId
			);
			if (currentOption) {
				this.setState({
					selectedOption: currentOption.id
				});
			}
		});
	};

	getOptions = question => {
		const { selectedOption } = this.state;
		return question.options.map((option, key) => {
			return (
				<Options
					option={option}
					key={key}
					onOptionClick={this.onOptionClick}
					isHighlighted={selectedOption === option.id}
				/>
			);
		});
	};

	render() {
		const { question, index } = this.props;
		return (
			<div className={styles["question-box"]}>
				<div className={styles["question"]}>
					<div style={{ marginRight: "10px" }}>Q{index + 1}.</div>
					<div>{question.text}</div>
				</div>
				<div className={styles["option-body"]}>
					{this.getOptions(question)}
				</div>
			</div>
		);
	}
}

Questions.propTypes = {};

Questions.defaultProps = {};

export default Questions;



// WEBPACK FOOTER //
// /src/components/commonComponents/surveyView/questions/Questions.js